export default __webpack_public_path__ + "static/media/antenna.6b7009c3.png";